import React, { useContext } from 'react';
import defaultLogo from '@/assets/images/tmt_logo_hor.png';
import { ConfigContext } from '@/contextAPI/configContext';
import { FocusAvail, FocusVersionScheduling } from '@/redux/slices/slice_types';
import styled from '@emotion/styled';

type EntityWithTitle = {
  version?: any;
  title?: any;
};

const FocusImage = ({ entity }: { entity: FocusVersionScheduling | FocusAvail | EntityWithTitle }) => {
  const logo = useContext(ConfigContext)?.theme?.logo || defaultLogo;
  const title = entity?.version || entity?.title;

  return (
    <StyledImg
      src={title?.title_thumbnail_link || logo}
      alt={`${title?.title_name_supplemental} ${title?.title_name}`}
      default={title?.title_thumbnail_link}
    />
  );
};

export default FocusImage;

const StyledImg = styled('img')<{ default: string | null }>`
  max-width: ${(props) => (props.default ? '100%' : '80%')};
  max-height: ${(props) => (props.default ? '100%' : '80%')};
`;
